import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FullField from '../FormElements/FullField';
import Button from '../ui/Button';
import ErrorBlock from '../ui/ErrorBlock';
import styles from './ResetPassword.module.scss';
import commonStyles from '../../theme/common.module.scss';

const resetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, 'Too short!')
    .max(25, 'Too long!')
    .matches(
      //forcing a special character too for stronger passwords -->(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})
      /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
      'Password must contain at least an uppercase letter, a lowercase letter, and a numeric character'
    )
    .required('Required'),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords are not the same!')
    .required('Required'),
});

const ResetPasswordForm = (props) => {
  const testData = process.env.NODE_ENV === 'development' && true; // change to false when testing without data
  const defaultData = {
    password: testData ? 'Admin543' : '',
    passwordConfirmation: testData ? 'Admin543' : '',
  };
  const { onSubmit, serverError, loading } = props;
  return (
    <section className={`${commonStyles.mainGrid} ${styles.resetPassword}`}>
      <h1 className={styles.title}>Pick a new password</h1>
      <Formik initialValues={defaultData} validationSchema={resetPasswordSchema} onSubmit={onSubmit}>
        {({ errors, touched, values }) => (
          <Form className={styles.block}>
            <FullField
              label='Password*'
              name='password'
              type='password'
              error={touched.password ? errors.password : null}
            />
            <FullField
              label='Repeat Password*'
              name='passwordConfirmation'
              type='password'
              error={touched.passwordConfirmation ? errors.passwordConfirmation : null}
            />
            <Button type='submit' loading={loading}>
              Submit
            </Button>
            <ErrorBlock>{props.serverError}</ErrorBlock>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default ResetPasswordForm;
